import request from '@/utils/request'
import { encryptedData } from '@/utils/encrypt'
import { loginRSA, tokenName } from '@/config'

// 新用户添加修改
export function Monad_update(data) {
  return request({
    url: 'kor_admin/Monad/update',
    method: 'post',
    data,
  })
}
// 新用户详情
export function Monad_detail(data) {
  return request({
    url: 'kor_admin/Monad/detail',
    method: 'post',
    data,
  })
}
// 新用户删除
export function Monad_del(data) {
  return request({
    url: 'kor_admin/Monad/del',
    method: 'post',
    data,
  })
}
// 新用户删除
export function Monad_list(data) {
  return request({
    url: 'kor_admin/Monad/list',
    method: 'post',
    data,
  })
}
// 新用户导入
export function Monad_excel_add(data) {
  return request({
    url: 'kor_admin/Monad/excel_add',
    method: 'post',
    data,
  })
}
// 新物品纸箱添加/修改
export function MonadCarton_update(data) {
  return request({
    url: 'kor_admin/MonadCarton/update',
    method: 'post',
    data,
  })
}
// 新物品纸箱详情
export function MonadCarton_detail(data) {
  return request({
    url: 'kor_admin/MonadCarton/detail',
    method: 'post',
    data,
  })
}
// 新物品纸箱删除
export function MonadCarton_del(data) {
  return request({
    url: 'kor_admin/MonadCarton/del',
    method: 'post',
    data,
  })
}
// 新物品纸箱列表
export function MonadCarton_list(data) {
  return request({
    url: 'kor_admin/MonadCarton/list',
    method: 'post',
    data,
  })
}
// 新包裹修改
export function MonadOrder_update(data) {
  return request({
    url: 'kor_admin/MonadOrder/update',
    method: 'post',
    data,
  })
}
// 新包裹删除
export function MonadOrder_del(data) {
  return request({
    url: 'kor_admin/MonadOrder/del',
    method: 'post',
    data,
  })
}
// 新包裹详情
export function MonadOrder_detail(data) {
  return request({
    url: 'kor_admin/MonadOrder/detail',
    method: 'post',
    data,
  })
}
// 新包裹列表
export function MonadOrder_list(data) {
  return request({
    url: 'kor_admin/MonadOrder/list',
    method: 'post',
    data,
  })
}
// 新包裹导出
export function MonadOrder_excel_out(data) {
  return request({
    url: 'kor_admin/MonadOrder/excel_out',
    method: 'post',
    data,
  })
}


